'use client';

import { SessionProvider as NextAuthSessionProvider } from 'next-auth/react';
import { ReactNode } from 'react';
import { SessionExpiryGuard } from './session-expiry-guard';

// FF-481: refetchInterval=120 (poll every 2 min) + refetchOnWindowFocus=true
// drives SessionExpiryGuard. Paired with rolling JWT refresh in src/lib/auth.ts
// so active operators never silently expire.
export function SessionProvider({ children }: { children: ReactNode }) {
  return (
    <NextAuthSessionProvider
      refetchInterval={120}
      refetchOnWindowFocus={true}
    >
      <SessionExpiryGuard />
      {children}
    </NextAuthSessionProvider>
  );
}
